import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";

dayjs.extend(weekday);

const getDayjsCalendarInstance = (date, format) => dayjs(date, format);

export default getDayjsCalendarInstance;
